/* 
import '../scripts/utils/theme-functions.js';
import '../scripts/utils/css-helpers.js';
*/

if (!window.theme) {
    window.theme = {};
}

import '../scripts/components/';
import '../scripts/utils/lazy-images.js';
import '../scripts/utils/theme-functions.js';
import '../scripts/animations/animations.js';

import Flickity from 'flickity';

window.Flickity = Flickity;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.dispatchEvent(new CustomEvent('theme:loaded'));
    });
} else {
    window.dispatchEvent(new CustomEvent('theme:loaded'));
}
